<template>
  <div>
    <button
      id="cart"
      class="nav-link text-dark font-weight-bold text-uppercase"
      title="Merkliste"
      tabindex="12"
      style="
        border: none;
        border-color: gray;
        background-color: transparent;
        cursor: pointer;
        position: relative;
      "
      @click="showMerkliste = true"
    >
      Merkliste
      <i
        class="fas fa-clipboard-list"
        style="font-size: 16px"
      />
      <div
        :class="{
          bookmarkNumber: merkliste.length < 10,
          bookmarkNumberLong: merkliste.length > 9,
        }"
      >
        {{ merkliste.length }}
      </div>
    </button>
    <div
      v-show="showMerkliste"
      id="grayOut"
      style="
        width: 100%;
        height: 100%;
        background-color: black;
        z-index: 98;
        opacity: 0.4;
        display: none;
        position: fixed;
        top: 0;
        left: 0;
      "
      @click="showMerkliste = false"
    />
    <div
      v-show="showMerkliste"
      class="merkliste shadow"
      style="
        width: 700px;
        position: absolute;
        right: 0px;
        z-index: 99;
        margin-top: 5px;
        border-style: solid;
        border-width: 1px;
      "
    >
      <i
        class="fas fa-times"
        style="
          top: 0;
          right: 0;
          position: absolute;
          cursor: pointer;
          font-size: 19px;
          color: white;
          padding: 1px 4px;
          border-radius: 2px;
          background-color: red;
        "
        @click="showMerkliste = false"
      />
      <h6>Merkliste</h6>
      <div style="padding-top: 10px">
        <div v-show="merkliste.length == 0">
          Keine Verträge in der Merkliste
        </div>
        <div
          v-for="(merkListenItem, index) in merkliste"
          :key="index"
        >
          <hr
            style="background-color: white; margin-top: 5px; margin-bottom: 5px"
          >
          <div>
            <i
              class="fas fa-times"
              style="
                float: right;
                margin-top: 1px;
                cursor: pointer;
                font-size: 16px;
              "
              @click="removeItemFromMerkliste(index)"
            />
            <div class="merkListeCheckBox">
              <label>
                <input
                  :id="'MerklisteItem' + index"
                  v-model="selectedItems"
                  type="checkbox"
                  :value="merkListenItem"
                  name="check"
                >
                <span class="label-text">
                  {{ merkListenItem.DisplayName }} (Version
                  {{ merkListenItem.Version }}, Edition
                  {{ merkListenItem.Edition }})
                  <router-link
                    v-b-tooltip.hover
                    :to="
                      '/contract-overview/' +
                        merkListenItem.GavNumber +
                        '/' +
                        merkListenItem.Version
                    "
                    placement="bottom"
                    title="Vertrag öffnen"
                    class="mx-1"
                  ><i class="fas fa-external-link-alt" />
                  </router-link>
                </span>
              </label>
            </div>
          </div>
        </div>
        <hr style="background-color: red; padding: 1; /* margin: 18px; */">
        <div
          class="btn-link showDifferencesMerkliste"
          :class="{ disabled: selectedItems.length != 2 }"
        >
          <router-link
            v-if="selectedItems.length == 2"
            :to="compareUrl"
          >
            Unterschiede anzeigen
          </router-link>
          <div v-else>
            Unterschiede anzeigen
          </div>
        </div>
        <div
          class="btn-link"
          :class="{ disabled: selectedItems.length < 2 }"
          @click="compareSelectedItems"
        >
          Ausgewählte Versionen vergleichen
        </div>
        <div
          class="btn-link"
          :class="{ disabled: merkliste.length < 2 }"
          @click="compareAllItems"
        >
          Alle Versionen in Merkliste vergleichen
        </div>
        <div
          class="btn-link"
          :class="{ disabled: merkliste.length < 1 }"
          @click="removeAllMerklistItems"
        >
          Merkliste löschen
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  loadMerkliste,
  saveMerkliste,
  removeSingleItemFromMerkliste,
  removeAllItemsFromMerkliste,
} from "@/helpers/BookmarksHelper.js";

export default {
  data() {
    return {
      merkliste: [],
      selectedItems: [],
      showMerkliste: false,
    };
  },
  computed: {
    compareUrl() {
      if (this.selectedItems && this.selectedItems.length > 1) {
        var contract1Object = {
          c: this.selectedItems[0].GavNumber,
          v: this.selectedItems[0].Version,
          e: this.selectedItems[0].Edition,
        };
        var contract2Object = {
          c: this.selectedItems[1].GavNumber,
          v: this.selectedItems[1].Version,
          e: this.selectedItems[1].Edition,
        };

        return (
          "/CompareContracts?contract1=" +
          JSON.stringify(contract1Object) +
          "&contract2=" +
          JSON.stringify(contract2Object)
        );
      }

      return "";
    },
  },
  created: function () {
    this.merkliste = loadMerkliste();

    this.$eventBus.$on("bookmarkAdded", () => {
      this.merkliste = loadMerkliste();
    });
  },
  methods: {
    saveMerkliste() {
      this.merkliste = saveMerkliste(this.merkliste);
    },
    removeAllMerklistItems() {
      this.merkliste = removeAllItemsFromMerkliste();
      this.selectedItems = [];

      this.$eventBus.$emit("bookmarkUpdated");
    },
    removeItemFromMerkliste(index) {
      this.merkliste = removeSingleItemFromMerkliste(index);
      this.selectedItems = [];

      this.$eventBus.$emit("bookmarkUpdated");
    },
    compareSelectedItems() {
      this.$store.commit("setContractsToCompare", this.selectedItems);

      this.$router.push({
        path: "/CompareMultipleContracts",
      });
    },
    compareAllItems() {
      this.$store.commit("setContractsToCompare", this.merkliste);

      this.$router.push({
        path: "/CompareMultipleContracts",
      });
    },
  },
};
</script>

<style scoped src="@/assets/css/Checkbox.css"></style>
<style>
.merkliste:after {
  bottom: 100%;
  left: 89%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: #343a40;
  border-width: 8px;
  margin-left: -8px;
}

.merkliste {
  margin: 20px 0;
  float: right;
  background: white;
  width: 550px;
  position: relative;
  border-radius: 3px;
  padding: 20px;
}

.btn-link {
  color: red !important;
  cursor: pointer;
}

.btn-link.disabled {
  color: gray !important;
}

.bookmarkNumber {
  color: red;
  right: -2px;
  top: -2px;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
}

.bookmarkNumberLong {
  color: red;
  right: -9px;
  top: -2px;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
}
</style>
